import { render } from "./ProductDetail_DataGovernance.vue?vue&type=template&id=cdf13cce&scoped=true"
import script from "./ProductDetail_DataGovernance.vue?vue&type=script&lang=js"
export * from "./ProductDetail_DataGovernance.vue?vue&type=script&lang=js"

import "./ProductDetail_DataGovernance.vue?vue&type=style&index=0&id=cdf13cce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdf13cce"]])

export default __exports__